import React, { Component } from "react";
import { loggerEventMessage, loggerEventName, loggerEventOutcome, loggerEventTypes } from "../../../helpers/messages";
import { logger } from "../../../services/logger/logger-service";

export default class DevicePassword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showPassword: props.isVisible || false,
			hideTimerId: null,
		};
	}

	componentWillUnmount() {
		const { hideTimerId } = this.state;
		if (hideTimerId) {
			clearTimeout(hideTimerId);
		}
	}

	/**
	 * @description Function to get the template to show password/key
	 * @memberof DevicePassword
	 */
	getFieldTemplate = () => {
		const { value, type, htmlID } = this.props;
		const { showPassword } = this.state;
		switch (type) {
			case 'password':
				return (showPassword ?
					<span className="form-control user-select-none" data-testid={`${htmlID}-default-value`}>{value}</span>
					: <input
						type={!value ? "text" : "password"}
						className={`form-control user-select-none pe-none ${value ? 'key-input-blur' : ''}`}
						data-testid={`${htmlID}-password-input`}
						value={this.getHiddenValue(value)}
						readOnly
						disabled={!value}
					/>
				)

			case 'key':
			case 'tpm':
				return (
					showPassword ? <pre><code className="form-control device-key user-select-none" data-testid={`${htmlID}-default-value`}>{value}</code></pre> :
						<textarea className={`form-control device-key user-select-none ${!showPassword && value ? 'key-input-blur' : ''}`}
							rows={4}
							value={showPassword ? value : this.getHiddenValue(value)}
							disabled={!value}
							readOnly
						></textarea>
				)
			/* istanbul ignore next  */
			default:
				return '';
		}
	}

	/**
	 * @description Function to hide the value from UI
	 * @param value String value for the field
	 * @memberof DevicePassword
	 */
	getHiddenValue = (value) => {
		if (!value) {
			return 'Unavailable';
		}
		let hiddenValue = '';
		for (let i = 0; i < value.length; i++) {
			hiddenValue += '*'
		}

		return hiddenValue;
	}

	/**
	 * @description Function to toggle show and hide password
	 * @memberof DevicePassword
	 */
	togglePasswordVisibility = () => {
		const { value } = this.props;
		/* istanbul ignore next  */
		if (!value) {
			return false;
		}
		const { showPassword } = this.state;
		this.setState({ showPassword: !showPassword }, () => {
			if (this.state.showPassword) {
				this.startHideTimer();
				this.logView()
			} else {
				this.clearHideTimer();
			}
		});
	};

	/**
	 * @description Function to start the 20 second timer for auto-hide password
	 * @memberof DevicePassword
	 */
	/* istanbul ignore next  */
	startHideTimer = () => {
		const { hideTimerId } = this.state;
		if (hideTimerId) {
			clearTimeout(hideTimerId);
		}

		const newHideTimerId = setTimeout(() => {
			this.setState({ showPassword: false, hideTimerId: null });
		}, 20000); // 20 seconds timer
		this.setState({ hideTimerId: newHideTimerId });
	};

	/**
	 * @description Function to end and clear timer for auto-hide password
	 * @memberof DevicePassword
	 */
	clearHideTimer = () => {
		const { hideTimerId } = this.state;
		if (hideTimerId) {
			clearTimeout(hideTimerId);
			this.setState({ hideTimerId: null });
		}
	};

	/**
	 * @description Function to stop copy and other action on the field
	 * @memberof DevicePassword
	 */
	preventDefaultAction = (event) => {
		event.preventDefault();
	}

	/**
	 * @description function to handle application logs for viewing password/key
	 * @memberof DevicePassword
	 */
	logView = () => {
		const { type, label } = this.props;
		const loggerObj = {
			EventOutcome: loggerEventOutcome.success,
			EventType: loggerEventTypes.read,
			EventName: loggerEventName.viewPassKey(type),
			Content: {
				Data: loggerEventMessage.passKeyViewed(label)
			}
		};

		logger(loggerObj);
	}

	render() {
		const { id, label, value, type, hideCheckbox, handleCheckSelection, checked, htmlID, handleDownload } = this.props;
		const { showPassword } = this.state;
		return (
			<>
				<div className="row" data-testid={`${htmlID}-password-info-box`} onMouseDown={this.preventDefaultAction} onContextMenu={this.preventDefaultAction} onCopy={this.preventDefaultAction} onKeyUp={this.preventDefaultAction}>
					<div className="col-sm-12 mb-1">
						<div className="d-flex justify-content-between">
							<div className="label-title">
								<label className="chk-label">
									{!hideCheckbox ?
										<input
											type="checkbox"
											id={`${id}-checkbox`}
											data-testid={`${htmlID}-checkbox`}
											className="chk-input"
											disabled={!value}
											onChange={(e) => handleCheckSelection(type, htmlID, e.target.checked)}
											checked={checked}
										/>
										: ''}
									<span className="col-form-label fw-500 ps-1 cursor-pointer" title={label}>{label}</span>
								</label>
							</div>
							{value && (
								<div className="d-flex align-items-center justify-content-end">
									<div className="me-2" role="button" data-testid={`${htmlID}-show-hide-btn`} title={showPassword ? "Hide" : "View"} onClick={this.togglePasswordVisibility}>
										{!showPassword ? (
											<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" className="bi bi-eye-slash fw-bold" viewBox="0 0 16 16" >
												<path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
												<path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
												<path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
											</svg>
										) : (
											<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" className="bi bi-eye fw-bold" viewBox="0 0 16 16">
												<path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
												<path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
											</svg>
										)}
									</div>
									<div role="button" data-testid={`${htmlID}-download-password`} title="Download" onClick={(e) => handleDownload(type, 'single', htmlID)}>
										<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" className="bi bi-download fw-bold" viewBox="0 0 16 16">
											<path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
											<path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
										</svg>
									</div>
								</div>
							)}
						</div>
					</div>
					<div className="col-sm-12">
						<div className="form-group">
							{this.getFieldTemplate()}
						</div>
					</div>
				</div>
			</>
		);
	}
}
